import React, { useState } from 'react';

const Menu = ({ chat, setSelectedChatId }) => {
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div className='menu'>
      <div
        className='menu-button'
        onClick={() => {
          chat && setSelectedChatId(null);
          setShowInfo(false);
        }}
      >
        {!chat ? (
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M3 12L15 12M3 6L21 6M3 18L21 18'
              stroke='#FFFEFD'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        ) : (
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M15 6L9 12L15 18'
              stroke='#FFFEFD'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        )}
      </div>
      <div className='menu-title' style={{ textAlign: 'center', width: '60%' }}>
        {chat?.client?.name ? chat?.client?.name : 'Чати'}
      </div>

      {chat && (
        <div className='info-button' onClick={() => setShowInfo(!showInfo)}>
          <svg
            width='24'
            height='25'
            viewBox='0 0 24 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M12.0871 16.5V12M12.0871 8.49997H12.0771M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5Z'
              stroke='#FFFEFD'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      )}

      {chat && (
        <div
          className={`info-container ${setShowInfo ? 'open' : ''}`}
          style={{ transform: showInfo ? 'scale(1)' : 'scale(0)' }}
        >
          <div style={{ textAlign: 'center', width: '100%' }}>
            <div>Дані запиту</div>
          </div>
          <div>
            Марка: <div>{chat?.requestData?.mark ?? 'не вказано'}</div>
          </div>
          <div>
            Модель: <div>{chat?.requestData?.model ?? 'не вказано'}</div>
          </div>
          <div>
            Рік випуску: <div>{chat?.requestData?.year ?? 'не вказано'}</div>
          </div>
          <div>
            VIN: <div>{chat?.requestData?.vin ?? 'не вказано'}</div>
          </div>
          <div>
            Телефон: <div>{chat?.client?.phone ?? 'не вказано'}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Menu;
